import { notify } from 'utils/reduxUtils';

export const types = {
  DELETE_REQUEST: 'opDefs/detailsPage/DELETE_REQUEST',
  DELETE_SUCCESS: 'opDefs/detailsPage/DELETE_SUCCESS',
  DELETE_ERROR: 'opDefs/detailsPage/DELETE_ERROR',
  COPY_REQUEST: 'opDefs/detailsPage/COPY_REQUEST',
  COPY_SUCCESS: 'opDefs/detailsPage/COPY_SUCCESS',
  COPY_ERROR: 'opDefs/detailsPage/COPY_ERROR',
};

export const deleteOpDef = {
  request: () => ({
    type: types.DELETE_REQUEST,
  }),
  success: () => ({
    type: types.DELETE_SUCCESS,
  }),
  error: () => ({
    type: types.DELETE_ERROR,
  }),
};

export const copyOpDef = {
  request: () => ({
    type: types.COPY_REQUEST,
  }),
  success: () => ({
    type: types.COPY_SUCCESS,
  }),
  error: notify(
    ({ error }) => ({
      type: types.COPY_ERROR,
      payload: error,
    }),
    'Failed to duplicate operation.',
  ),
};
